import React from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { styles } from './ImagePreview.styles';
import closeImageIcon from 'src/assets/closeImageIcon.png';

// Define the props type
type ImagePreviewProps = {
  source: string; // URL of the image
  onIconPress?: () => void; // Optional function when the icon is pressed
  testID?: string;
};

const ImagePreview: React.FC<ImagePreviewProps> = ({ source, onIconPress, testID }) => {
  return (
    <View style={styles.previewContainer} testID={testID}>
      {/* Icon positioned above and to the right */}
      <TouchableOpacity style={styles.iconContainer} onPress={onIconPress}>
        <Image source={closeImageIcon} style={styles.icon} accessibilityLabel="close icon" />
      </TouchableOpacity>

      {/* Image Display */}
      <Image source={{ uri: source }} style={styles.imagePreview} />
    </View>
  );
};

export default ImagePreview;
